<template>
  <p class="text-12 text-grey-light">
    <slot />
  </p>
</template>
